'use client';

import FloatingFaq from '@svg/main/floating_faq.svg';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export default function FloatingFaqButton() {
  const router = useRouter();
  const [portalElement, setPortalElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setPortalElement(document.getElementById('portal'));
  }, []);

  const handleClick = () => {
    if (window.location.pathname.startsWith('/poi/')) {
      router.back();
      setTimeout(() => {
        router.push('/customercenter/faq');
      }, 100);
    } else {
      router.push('/customercenter/faq');
    }
  };

  if (!portalElement) return null;

  return createPortal(
    <button
      onClick={handleClick}
      className='fixed bottom-114pxr z-25'
      style={{
        right: 'max(20px, (calc(100vw - 480px) / 2) + 20px)',
      }}
    >
      <FloatingFaq />
    </button>,
    portalElement,
  );
}
